var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAldagiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.29 80.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0a1a1a;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.39,74.05s-.01-51.65-.01-51.65c0-1.75.47-3.12,1.42-4.11.95-.99,2.23-1.49,3.83-1.49s2.88.5,3.83,1.49c.95.99,1.42,2.36,1.42,4.11v51.65h6.41V22.4c0-3.55-1.07-6.37-3.2-8.44-2.14-2.08-4.96-3.12-8.46-3.12s-6.32,1.04-8.46,3.12c-2.14,2.08-3.2,4.89-3.2,8.44v51.65s6.42,0,6.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.23,62.5c0,3.55-1.07,6.37-3.2,8.44-2.14,2.08-4.95,3.12-8.46,3.12s-6.32-1.04-8.46-3.12c-2.14-2.08-3.2-4.89-3.2-8.44v-18.44h6.41v18.44c0,1.75.48,3.12,1.42,4.11.95.99,2.23,1.49,3.83,1.49s2.88-.5,3.83-1.49c.95-.99,1.42-2.36,1.42-4.11,0,0-.01-18.88-.01-18.88.02-17.11-10.48-14.09-10.48-28.87,0-.81-.03-2.11-.01-3.01,0,0,6.42,0,6.42,0,0,1.5,0,1.76,0,2.9,0,10.89,10.49,10.04,10.49,28.72v19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.73,43.36v19.13c0,3.55-1.07,6.37-3.2,8.44-2.14,2.08-4.96,3.12-8.46,3.12s-6.32-1.04-8.46-3.12c-2.14-2.08-3.2-4.89-3.2-8.44v-18.44h6.41v18.44c0,1.75.48,3.12,1.43,4.11.95.99,2.22,1.49,3.83,1.49s2.88-.5,3.83-1.49c.95-.99,1.42-2.36,1.42-4.11v-18.88c0-17.11-10.49-14.09-10.49-28.86,0-.81-.03-2.11-.01-3.01h6.42c0,1.5,0,1.76,0,2.9,0,10.89,10.49,10.04,10.49,28.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.01,49.93v-27.53c0-3.55-1.07-6.37-3.2-8.44-2.14-2.08-4.95-3.12-8.46-3.12s-6.32,1.04-8.46,3.12c-2.14,2.08-3.2,4.89-3.2,8.44v26.42c0,5.58.33,8.89,5.86,13.97,2.51,2.3,5.94,4.72,5.94,11.25h6.41c0-.84.49-9.66-7.36-15.23-2.86-2.03-4.5-4.23-4.5-10.12l.06-26.3c0-1.75.47-3.12,1.42-4.11.95-.99,2.23-1.49,3.83-1.49s2.88.5,3.83,1.49c.95.99,1.42,2.36,1.42,4.11v27.53h6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.64,13.96c-2.14-2.08-4.96-3.12-8.46-3.12s-6.32,1.04-8.46,3.12c-2.14,2.07-3.2,4.89-3.2,8.44v26.48c0,5.58.33,8.84,5.86,13.92,2.51,2.3,5.94,4.71,5.94,11.25h6.41c0-.84.49-9.67-7.37-15.23-2.72-1.93-4.34-3.65-4.5-8.89h5.32c3.44,0,6.24-1.05,8.41-3.16,2.17-2.11,3.24-4.94,3.24-8.49v-15.88c0-3.55-1.07-6.37-3.2-8.44ZM176.02,42.02c-.95,1.02-2.22,1.54-3.83,1.54h-5.26v-21.16c0-1.74.47-3.12,1.42-4.11.95-.99,2.22-1.49,3.83-1.49s2.88.5,3.83,1.49c.95.99,1.42,2.36,1.42,4.11v15.47c0,1.74-.47,3.13-1.42,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.39,33.88s4.56-2.73,4.56-11.31-4.07-11.71-10.58-11.71c-5.3,0-10.21,3.38-10.21,9.88v5.72h6.4c0-2.32,0-2.18,0-3.95,0-.87-.3-5.71,3.89-5.71,4.41,0,4.13,4.83,4.13,5.7,0,3.33-.24,6.38-4.63,8.94-4.4,2.56-10.78,3.73-10.78,14.13v15.9c0,5.4,2.24,12.59,11.33,12.59,6.65,0,11.99-3.63,11.99-11.82v-16.87c0-2.95-.58-8.97-6.1-11.5ZM235.08,62.5c0,1.75-.48,3.12-1.42,4.11-.95.99-2.23,1.49-3.83,1.49s-2.88-.5-3.83-1.49c-.95-.99-1.42-2.36-1.42-4.11v-18.63c0-1.75.48-3.12,1.42-4.11.95-.99,2.23-1.49,3.83-1.49s2.88.5,3.83,1.49c.95.99,1.42,2.36,1.42,4.11v18.63Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,49.71h80.74s0,3.62,0,3.62H0s0-3.62,0-3.62ZM0,59.65h80.74s0,2.82,0,2.82H0s0-2.82,0-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.37,0h0c-8.83,0-17,2.84-23.64,7.64h47.28C57.36,2.84,49.2,0,40.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.9,9.94H13.84c-2.33,2.03-4.42,4.33-6.23,6.84h65.53c-1.81-2.51-3.91-4.81-6.23-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.16,19.88H5.57c-1.13,1.92-2.11,3.93-2.91,6.04h75.42c-.81-2.1-1.78-4.12-2.91-6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.35,29.83H1.39c-.46,1.7-.81,3.45-1.05,5.23h80.06c-.23-1.78-.59-3.53-1.05-5.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 39.77,
    width: 80.74,
    height: 4.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 49.71,
    width: 80.74,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 59.65,
    width: 80.74,
    height: 2.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 69.59,
    width: 80.74,
    height: 2.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 79.54,
    width: 80.74,
    height: 1.21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAldagiLogo);
export default __webpack_public_path__ + "static/media/aldagi-logo.4df7c3b47d703cd84db0b7a1128e76d2.svg";
export { ForwardRef as ReactComponent };